import { render, staticRenderFns } from "./historique-configs.html?vue&type=template&id=bc13b3dc&scoped=true&external"
import script from "./historique-configs.js?vue&type=script&lang=js&external"
export * from "./historique-configs.js?vue&type=script&lang=js&external"
import style0 from "./historique-configs.scss?vue&type=style&index=0&id=bc13b3dc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc13b3dc",
  null
  
)

export default component.exports